const custom = [
    {
        "ID" : 1,
        "name":"Commercial Sample"
    },{
        "ID" : 2,
        "name": "Gift"
    },{
        "ID" : 3,
        "name": "Document"
    },{
        "ID" : 4,
        "name": "Returned Goods"
    },{
        "ID" : 5,
        "name": "Other"
    },{
        "ID" : 6,
        "name": "Merchandise"
    },{
        "ID" : 6,
        "name": "Humanitarian Donation"
    },{
        "ID" : 7,
        "name": "Dangerous Goods"
    }
]
export default custom;